<div [ngClass]="[position]" [bpTooltip]="status?.description || status?.displayName"></div>
